import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AreaLocalProvider } from '../area-local/area-local';
import { Atalho } from '../../models/atalho';
import { AreaAdmin, AreaComum } from '../../models/area';
import { BrComService } from '../../service/BrComService'
import { EmpresaLocalProvider } from '../empresa-local/empresa-local';
import { HttpServidor } from '../shared/abstract/http-servidor';
import { AreaAdminLocalProvider } from '../area-admin-local/area-admin-local';

interface dadosAtualizacaoEmpresa {
  atalhos: Atalho[],
  nomeEmpresa: string,
  hashLogotipo: string,
  site: string,
  facebook: string,
  twitter: string,
  areas: AreaComum[],
  areasAdmin: AreaAdmin[],
  layoutRotinas: number,
  tituloSetor: string,
  tituloCentroDeCusto: string
}

interface dadosAtualizacaoUsuario {
  nomeUsuario: string
}

@Injectable()
export class EmpresaProvider extends HttpServidor {

  constructor(http: HttpClient, 
    private areaLocalProvider: AreaLocalProvider,
    private empresaLocalProvider: EmpresaLocalProvider,
    private brComService: BrComService,
    private areaAdminLocalProvider: AreaAdminLocalProvider,
  ) {
    super(http);
  }

  private getInformacoesRecentesDaEmpresa(empresa: any): Observable<dadosAtualizacaoEmpresa> {
    const form = new FormData();
    form.append('cod_empresa', JSON.stringify(empresa.CodEmpresa));
    form.append('id_usuario', JSON.stringify(empresa.IdUsuario));
    form.append('id_device', JSON.stringify(this.brComService.getIdDevice()));
    return this.post('infoEmpresa', form);
  }

  private getInformacoesRecentesDoUsuario(empresa: any): Observable<dadosAtualizacaoUsuario> {
    const form = new FormData();
    form.append('id_usuario', JSON.stringify(empresa.IdUsuario));
    return this.post('infoUsuario', form);
  }

  public atualizarEmpresa(): void {
    const empresa = this.empresaLocalProvider.getEmpresa();
    if (!empresa) {
      return
    }
    this.getInformacoesRecentesDaEmpresa(empresa).subscribe(
      (dados: dadosAtualizacaoEmpresa) => {
        this.areaLocalProvider.setAreas(dados.areas);
        this.areaAdminLocalProvider.setAreas(dados.areasAdmin);
        empresa.Atalhos = dados.atalhos;
        empresa.HashLogotipoEmpresa = dados.hashLogotipo;
        empresa.NomeEmpresa = dados.nomeEmpresa;
        empresa.Site = dados.site;
        empresa.Facebook = dados.facebook;
        empresa.Twitter = dados.twitter;
        empresa.LayoutRotinas = dados.layoutRotinas;
        empresa.TituloSetor = dados.tituloSetor;
        empresa.TituloCentroDeCusto = dados.tituloCentroDeCusto;
        this.empresaLocalProvider.setEmpresa([empresa]);
      }
    )
  }


  public atualizarUsuario(): void {
    const empresa = this.empresaLocalProvider.getEmpresa();
    if (!empresa) {
      return
    }
    this.getInformacoesRecentesDoUsuario(empresa).subscribe(
      dados => {
        empresa.NomeUsuario = dados.nomeUsuario;
        this.empresaLocalProvider.setEmpresa([empresa]);
      }
    )
  }



}



// WEBPACK FOOTER //
// ./src/providers/empresa/empresa.ts